/**
 * Configuración de rutas con lazy loading
 * Usa hash routing para compatibilidad (#/path)
 */

import { lazy } from 'react';
import { createHashRouter } from 'react-router-dom';
import { DashboardLayout } from '@/shared/components/Layout/DashboardLayout';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute/ProtectedRoute';
import { UnderConstructionPage } from '@/shared/components/UnderConstructionPage';
import { LazyRouteWrapper } from '@/shared/components/LazyRouteWrapper';

// Lazy loading de módulos
const FormsPage = lazy(() =>
  import('@/modules/forms').then((mod) => ({ default: mod.FormPage }))
);

const AdmissionsPage = lazy(() =>
  import('@/modules/admissions').then((mod) => ({ default: mod.AdmissionsPage }))
);

const AuthLoginPage = lazy(() =>
  import('@/modules/auth').then((mod) => ({ default: mod.LoginPage }))
);

const ApplicationsPage = lazy(() =>
  import('@/modules/admissions').then((mod) => ({ default: mod.ApplicationsPage }))
);

const DashboardPage = lazy(() =>
  import('@/modules/platform/pages/DashboardPage').then((mod) => ({ default: mod.DashboardPage }))
);

export const router = createHashRouter([
  {
    path: '/auth/login',
    element: (
      <LazyRouteWrapper>
        <AuthLoginPage />
      </LazyRouteWrapper>
    ),
  },
  {
    path: '/admissions',
    element: (
      <LazyRouteWrapper>
        <AdmissionsPage />
      </LazyRouteWrapper>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'platform',
        element: <DashboardPage />,
      },
      {
        path: 'platform/dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'admissions/applications',
        element: <ApplicationsPage />,
      },
      {
        path: 'surveys',
        element: <UnderConstructionPage />,
      },
      {
        path: 'enrollments',
        element: <UnderConstructionPage />,
      },
      // Catch-all para cualquier otra ruta del menú que no esté implementada
      {
        path: '*',
        element: <UnderConstructionPage />,
      },
    ],
  },
  {
    path: '/forms/:instanceCode',
    element: (
      <LazyRouteWrapper>
        <FormsPage />
      </LazyRouteWrapper>
    ),
  },
]);

